import * as React from 'react';

interface IOptionProps {
  accesory: any;
  language?: string;
}

class Option extends React.Component<IOptionProps> {
  public render() {
    const { accesory, language } = this.props;

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row'
        }}
      >
        <div>
          <img
            style={{
              width: '60px',
              height: '60px',
              marginRight: 15,
            }}
            src={accesory.imageUrl || null}
          />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <div>
            <b>{language && accesory.name && accesory.name[language] || accesory.title}</b>
          </div>
          <div>{(accesory.value || {}).title}</div>
          <div><small>Item number: {accesory.ean}</small></div>
        </div>
      </div>
    );
  }
}

export default Option;


// WEBPACK FOOTER //
// ./src/components/Others/ProductSelect/components/Option/Option.tsx